import { render, staticRenderFns } from "./consult-info5.vue?vue&type=template&id=c5491902&scoped=true"
import script from "./consult-info5.vue?vue&type=script&lang=js"
export * from "./consult-info5.vue?vue&type=script&lang=js"
import style0 from "./consult-info5.vue?vue&type=style&index=0&id=c5491902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5491902",
  null
  
)

export default component.exports